import { useEffect } from 'react';
import useUnreadNotificationCount from './useUnreadNotificationCount';

const INTERVAL_DURATION = 60000;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useRefreshUnreadNotificationCounts = () => {
  const { getUnreadNotificationCount, isLoading } = useUnreadNotificationCount();

  useEffect(() => {
    getUnreadNotificationCount();
    const interval = setInterval(getUnreadNotificationCount, INTERVAL_DURATION);
    return () => clearInterval(interval);
  }, []);

  return { isLoading };
};

export default useRefreshUnreadNotificationCounts;
